export default "__VITE_ASSET__BpvSdDu$__"